import { Component, computed, inject, signal, Signal } from '@angular/core';
import { ProfileComponent } from '../profile/profile.component';
import { NgIf } from '@angular/common';
import { RouterLink, RouterLinkActive, ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    ProfileComponent,
    NgIf,
    RouterLink, 
    RouterLinkActive
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {

  profileVisible = false;
  private route: ActivatedRoute = inject(ActivatedRoute);
  private router:Router = inject(Router);
  open = false;

  private _title = signal<string>('dsfsdf');
  title: Signal<string> = computed(() => this._title());

  constructor() {
    this.router.events
      .pipe(filter((event: any) => event instanceof NavigationEnd))
      .subscribe(() => {
        const activeRoute = this.getDeepestChild(this.route);
        const data = activeRoute.snapshot.data;
        this._title.set(data['label'] || '');
      });
  }

  private getDeepestChild(route: ActivatedRoute): ActivatedRoute {
    let current = route;
    while (current.firstChild) {
      current = current.firstChild;
    }
    return current;
  }

  displayProfile() {
    this.profileVisible = !this.profileVisible;
  }

  openMenu() {
    console.log('Open Menu...');
  }

  test() {

  }

}
